import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  $serializer_getInstance3lbn6ctli2gxh as $serializer_getInstance,
  $serializer_getInstance4ifn58chloth as $serializer_getInstance_0,
  $serializer_getInstance1bw8y9ehxjeca as $serializer_getInstance_1,
  $serializer_getInstancebqw0kelmheg1 as $serializer_getInstance_2,
} from '../../serialization/VirtualType.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), $serializer_getInstance());
}
function LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_0() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), $serializer_getInstance_0());
}
function LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_1() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), $serializer_getInstance_1());
}
function LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_2() {
  return new (ArrayListSerializer())($serializer_getInstance_5());
}
function LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_3() {
  return new (ArrayListSerializer())($serializer_getInstance_4());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g3k_1 = [null, null, tmp_1, tmp_3, tmp_5, tmp_7, lazy(tmp_8, LightningServerKSchema$Companion$$childSerializers$_anonymous__uukkt1_3)];
      }
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.schema.LightningServerKSchema', this, 7);
        tmp0_serialDesc.a1b('baseUrl', false);
        tmp0_serialDesc.a1b('baseWsUrl', false);
        tmp0_serialDesc.a1b('structures', false);
        tmp0_serialDesc.a1b('enums', false);
        tmp0_serialDesc.a1b('aliases', true);
        tmp0_serialDesc.a1b('endpoints', false);
        tmp0_serialDesc.a1b('interfaces', false);
        this.t4n_1 = tmp0_serialDesc;
      }
      u4n(encoder, value) {
        var tmp0_desc = this.t4n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().g3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.v4n_1);
        tmp1_output.a15(tmp0_desc, 1, value.w4n_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x4n_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.y4n_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$0 = emptyMap();
          tmp = !equals(value.z4n_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.z4n_1);
        }
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.a4o_1);
        tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), value.b4o_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u4n(encoder, value instanceof LightningServerKSchema() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t4n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance().g3k_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.x13(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.x13(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, tmp12_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.x13(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return LightningServerKSchema().c4o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.t4n_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().g3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), tmp0_cached[4].f2(), tmp0_cached[5].f2(), tmp0_cached[6].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_3() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LightningServerKSchemaClass;
function LightningServerKSchema() {
  if (LightningServerKSchemaClass === VOID) {
    class $ {
      toString() {
        return 'LightningServerKSchema(baseUrl=' + this.v4n_1 + ', baseWsUrl=' + this.w4n_1 + ', structures=' + toString(this.x4n_1) + ', enums=' + toString(this.y4n_1) + ', aliases=' + toString(this.z4n_1) + ', endpoints=' + toString(this.a4o_1) + ', interfaces=' + toString(this.b4o_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.v4n_1);
        result = imul(result, 31) + getStringHashCode(this.w4n_1) | 0;
        result = imul(result, 31) + hashCode(this.x4n_1) | 0;
        result = imul(result, 31) + hashCode(this.y4n_1) | 0;
        result = imul(result, 31) + hashCode(this.z4n_1) | 0;
        result = imul(result, 31) + hashCode(this.a4o_1) | 0;
        result = imul(result, 31) + hashCode(this.b4o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LightningServerKSchema()))
          return false;
        if (!(this.v4n_1 === other.v4n_1))
          return false;
        if (!(this.w4n_1 === other.w4n_1))
          return false;
        if (!equals(this.x4n_1, other.x4n_1))
          return false;
        if (!equals(this.y4n_1, other.y4n_1))
          return false;
        if (!equals(this.z4n_1, other.z4n_1))
          return false;
        if (!equals(this.a4o_1, other.a4o_1))
          return false;
        if (!equals(this.b4o_1, other.b4o_1))
          return false;
        return true;
      }
      static c4o(seen0, baseUrl, baseWsUrl, structures, enums, aliases, endpoints, interfaces, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(111 === (111 & seen0))) {
          throwMissingFieldException(seen0, 111, $serializer_getInstance_3().t4n_1);
        }
        var $this = createThis(this);
        $this.v4n_1 = baseUrl;
        $this.w4n_1 = baseWsUrl;
        $this.x4n_1 = structures;
        $this.y4n_1 = enums;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp.z4n_1 = emptyMap();
        } else
          $this.z4n_1 = aliases;
        $this.a4o_1 = endpoints;
        $this.b4o_1 = interfaces;
        return $this;
      }
    }
    initMetadataForClass($, 'LightningServerKSchema', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    LightningServerKSchemaClass = $;
  }
  return LightningServerKSchemaClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.schema.LightningServerKSchemaInterface', this, 3);
        tmp0_serialDesc.a1b('matches', false);
        tmp0_serialDesc.a1b('docGroup', true);
        tmp0_serialDesc.a1b('path', false);
        this.d4o_1 = tmp0_serialDesc;
      }
      e4o(encoder, value) {
        var tmp0_desc = this.d4o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_2(), value.f4o_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.g4o_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.g4o_1);
        }
        tmp1_output.a15(tmp0_desc, 2, value.h4o_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e4o(encoder, value instanceof LightningServerKSchemaInterface() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d4o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return LightningServerKSchemaInterface().i4o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.d4o_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_4() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var LightningServerKSchemaInterfaceClass;
function LightningServerKSchemaInterface() {
  if (LightningServerKSchemaInterfaceClass === VOID) {
    class $ {
      toString() {
        return 'LightningServerKSchemaInterface(matches=' + this.f4o_1.toString() + ', docGroup=' + this.g4o_1 + ', path=' + this.h4o_1 + ')';
      }
      hashCode() {
        var result = this.f4o_1.hashCode();
        result = imul(result, 31) + (this.g4o_1 == null ? 0 : getStringHashCode(this.g4o_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.h4o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LightningServerKSchemaInterface()))
          return false;
        if (!this.f4o_1.equals(other.f4o_1))
          return false;
        if (!(this.g4o_1 == other.g4o_1))
          return false;
        if (!(this.h4o_1 === other.h4o_1))
          return false;
        return true;
      }
      static i4o(seen0, matches, docGroup, path, serializationConstructorMarker) {
        if (!(5 === (5 & seen0))) {
          throwMissingFieldException(seen0, 5, $serializer_getInstance_4().d4o_1);
        }
        var $this = createThis(this);
        $this.f4o_1 = matches;
        if (0 === (seen0 & 2))
          $this.g4o_1 = null;
        else
          $this.g4o_1 = docGroup;
        $this.h4o_1 = path;
        return $this;
      }
    }
    initMetadataForClass($, 'LightningServerKSchemaInterface', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    LightningServerKSchemaInterfaceClass = $;
  }
  return LightningServerKSchemaInterfaceClass;
}
function LightningServerKSchemaEndpoint$Companion$$childSerializers$_anonymous__gfjaba() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), $serializer_getInstance_2());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h3k_1 = [null, null, null, null, null, lazy(tmp_0, LightningServerKSchemaEndpoint$Companion$$childSerializers$_anonymous__gfjaba), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.schema.LightningServerKSchemaEndpoint', this, 10);
        tmp0_serialDesc.a1b('group', true);
        tmp0_serialDesc.a1b('description', false);
        tmp0_serialDesc.a1b('summary', false);
        tmp0_serialDesc.a1b('method', false);
        tmp0_serialDesc.a1b('path', false);
        tmp0_serialDesc.a1b('routes', false);
        tmp0_serialDesc.a1b('input', false);
        tmp0_serialDesc.a1b('output', false);
        tmp0_serialDesc.a1b('docGroup', false);
        tmp0_serialDesc.a1b('belongsToInterface', false);
        this.j4o_1 = tmp0_serialDesc;
      }
      k4o(encoder, value) {
        var tmp0_desc = this.j4o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().h3k_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.l4o_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.l4o_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.m4o_1);
        tmp1_output.a15(tmp0_desc, 2, value.n4o_1);
        tmp1_output.a15(tmp0_desc, 3, value.o4o_1);
        tmp1_output.a15(tmp0_desc, 4, value.p4o_1);
        tmp1_output.c15(tmp0_desc, 5, tmp2_cached[5].f2(), value.q4o_1);
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance_2(), value.r4o_1);
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance_2(), value.s4o_1);
        tmp1_output.d15(tmp0_desc, 8, StringSerializer_getInstance(), value.t4o_1);
        tmp1_output.d15(tmp0_desc, 9, $serializer_getInstance_2(), value.u4o_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k4o(encoder, value instanceof LightningServerKSchemaEndpoint() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j4o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.l13(tmp0_desc);
        var tmp15_cached = Companion_getInstance_1().h3k_1;
        if (tmp14_input.a14()) {
          tmp4_local0 = tmp14_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, $serializer_getInstance_2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.x13(tmp0_desc, 5, tmp15_cached[5].f2(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.x13(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.x13(tmp0_desc, 7, $serializer_getInstance_2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.z13(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.z13(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp14_input.m13(tmp0_desc);
        return LightningServerKSchemaEndpoint().v4o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      az() {
        return this.j4o_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_1().h3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5].f2(), $serializer_getInstance_2(), $serializer_getInstance_2(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_5() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var LightningServerKSchemaEndpointClass;
function LightningServerKSchemaEndpoint() {
  if (LightningServerKSchemaEndpointClass === VOID) {
    class $ {
      toString() {
        return 'LightningServerKSchemaEndpoint(group=' + this.l4o_1 + ', description=' + this.m4o_1 + ', summary=' + this.n4o_1 + ', method=' + this.o4o_1 + ', path=' + this.p4o_1 + ', routes=' + toString(this.q4o_1) + ', input=' + this.r4o_1.toString() + ', output=' + this.s4o_1.toString() + ', docGroup=' + this.t4o_1 + ', belongsToInterface=' + toString_0(this.u4o_1) + ')';
      }
      hashCode() {
        var result = this.l4o_1 == null ? 0 : getStringHashCode(this.l4o_1);
        result = imul(result, 31) + getStringHashCode(this.m4o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n4o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o4o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p4o_1) | 0;
        result = imul(result, 31) + hashCode(this.q4o_1) | 0;
        result = imul(result, 31) + this.r4o_1.hashCode() | 0;
        result = imul(result, 31) + this.s4o_1.hashCode() | 0;
        result = imul(result, 31) + (this.t4o_1 == null ? 0 : getStringHashCode(this.t4o_1)) | 0;
        result = imul(result, 31) + (this.u4o_1 == null ? 0 : this.u4o_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LightningServerKSchemaEndpoint()))
          return false;
        if (!(this.l4o_1 == other.l4o_1))
          return false;
        if (!(this.m4o_1 === other.m4o_1))
          return false;
        if (!(this.n4o_1 === other.n4o_1))
          return false;
        if (!(this.o4o_1 === other.o4o_1))
          return false;
        if (!(this.p4o_1 === other.p4o_1))
          return false;
        if (!equals(this.q4o_1, other.q4o_1))
          return false;
        if (!this.r4o_1.equals(other.r4o_1))
          return false;
        if (!this.s4o_1.equals(other.s4o_1))
          return false;
        if (!(this.t4o_1 == other.t4o_1))
          return false;
        if (!equals(this.u4o_1, other.u4o_1))
          return false;
        return true;
      }
      static v4o(seen0, group, description, summary, method, path, routes, input, output, docGroup, belongsToInterface, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(1022 === (1022 & seen0))) {
          throwMissingFieldException(seen0, 1022, $serializer_getInstance_5().j4o_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.l4o_1 = null;
        else
          $this.l4o_1 = group;
        $this.m4o_1 = description;
        $this.n4o_1 = summary;
        $this.o4o_1 = method;
        $this.p4o_1 = path;
        $this.q4o_1 = routes;
        $this.r4o_1 = input;
        $this.s4o_1 = output;
        $this.t4o_1 = docGroup;
        $this.u4o_1 = belongsToInterface;
        return $this;
      }
    }
    initMetadataForClass($, 'LightningServerKSchemaEndpoint', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    LightningServerKSchemaEndpointClass = $;
  }
  return LightningServerKSchemaEndpointClass;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstancehaaffmnyyk0,
  Companion_getInstance_1 as Companion_getInstance3mcqt6tk88j0w,
  Companion_instance_0 as Companion_instanceifrpuc0mopdh,
};
//endregion

//# sourceMappingURL=models.mjs.map
